export default __webpack_public_path__ + "static/media/free-cancellation.a3bcfb31.svg";